export default function () {
    (function ($) {

        let menuOpened = false;
        let fromTopScroll = 0;

        $(window).on('load', function () {


            var navHeight = $(".navigation").height();
            var infoHeight = 0;
            if ($(".navigation-info")) {
                infoHeight = $(".navigation-info").height();
            }
            document.documentElement.style.setProperty('--info-height', `${infoHeight ? infoHeight : 0}px`);
            window.addEventListener('resize', () => {
                navHeight = $(".navigation").height();
                infoHeight = $(".navigation-info").height() ? $(".navigation-info").height() : 0;
                document.documentElement.style.setProperty('--info-height', `${infoHeight ? infoHeight : 0}px`);
            });

            $(window).scroll(function (e) {
                e.preventDefault();
                var $count = navHeight;
                if (infoHeight) {
                    $count = navHeight + infoHeight;
                }
                if (infoHeight && $(window).scrollTop() >= infoHeight) {
                    $('.navigation').removeClass("top");
                } else if (!infoHeight && $(window).scrollTop() > 0) {
                    $('.navigation').removeClass("top");
                } else {
                    $('.navigation').addClass("top");
                }
                if ($(window).scrollTop() >= $count) {
                    $('.navigation__content_right').addClass("navigation__content_right-padding");
                } else {
                    $('.navigation:not(.opened) .navigation__content_right').removeClass("navigation__content_right-padding");
                }
                if ($(window).scrollTop() >= $count && !menuOpened) {
                    // if ($(window).scrollTop() > 0) {
                    $('.navigation').addClass("scrolled");
                    $('.navigation').removeClass("scrolled-anim");
                    $('.navigation.scrollUp').removeAttr("style");
                } else {
                    $('.navigation').removeClass("scrolled");
                    setTimeout(function () {
                        $('.navigation').addClass("scrolled-anim");
                    }, 300);
                }
            });

            $(".navigation__hamburger").on("click", function (ev) {
                if (menuOpened) {
                    close_hamburger_menu()
                } else {
                    open_hamburger_menu()
                }
            })

            function open_hamburger_menu() {
                menuOpened = true
                fromTopScroll = $(window).scrollTop();

                // Close search first
                close_search()

                // Open menu
                $(".navigation").addClass("opened");
                $(".navigation-placeholder").css("padding-bottom", navHeight + "px");
                $(".navigation__content").addClass("navigation__content--active");
                $(".navigation__hamburger-icon").addClass("navigation__hamburger-icon--opened");

                setTimeout(function () {
                    $('body').css({
                        position: "fixed",
                        overflow: "hidden",
                        top: -fromTopScroll,
                        width: "100%"
                    });
                }, 250);

                if (infoHeight && $(window).scrollTop() <= infoHeight) {
                    var $infoHeightActual = infoHeight - fromTopScroll;
                    $(".navigation.opened").css("top", $infoHeightActual);
                }
            }

            function close_hamburger_menu() {
                menuOpened = false
                var fromTop = $(window).scrollTop();
                $(".navigation").removeClass("opened");
                $(".navigation-placeholder").css("padding-bottom", "0");
                $('body').removeAttr("style");
                $(window).scrollTop(fromTopScroll);
                $(".navigation__content").removeClass("navigation__content--active");
                if (fromTop < 0) {
                    $(".navigation").addClass("scrollUp");
                }
                $(".navigation__content_right").removeAttr("style");
                $(".navigation__hamburger-icon").removeClass("navigation__hamburger-icon--opened");

                if (infoHeight && fromTop <= infoHeight) {
                    $(".navigation").css("top", '');
                }
            }

            // Search
            $('.navigation__search-open').on('click', open_search)
            $('.navigation__search-close, .navigation__search-overlay').on('click', close_search)

            function open_search() {
                let $search = $('.navigation__search--mobile');
                $search.addClass('open');
                if ($search.hasClass('open')) {
                    $search.find('.navigation__search-input').focus();
                }

                if (menuOpened) {
                    close_hamburger_menu()
                }
            }

            function close_search() {
                $('.navigation__search--mobile').removeClass('open');
            }

            // Script
            let lastScroll = 0;
            $(window).on('scroll', function () {
                var scroll = $(window).scrollTop();

                if (infoHeight === undefined) {
                    infoHeight = 0;
                }
                if (lastScroll - scroll > 0) {
                    $(".navigation").addClass("scrollUp");
                } else if (infoHeight - scroll > 0) {
                    $(".navigation").removeClass("scrollUp");
                } else if (scroll !== lastScroll) {
                    $(".navigation").removeClass("scrollUp");
                }
                if (scroll > 0) {
                    lastScroll = scroll;
                }
            });

            $(document).scroll(function () {
                var $count = navHeight;
                if (infoHeight) {
                    $count = navHeight + infoHeight;
                }
                if ($(this).scrollTop() > $count) {
                    $(".navigation").addClass("navigation-fixed");
                    $(".navigation-placeholder").css("padding-bottom", navHeight + "px");
                } else {

                    $('.navigation').css("transition", 'none');
                    $(".navigation").removeClass("navigation-fixed");
                    if (infoHeight && $(window).scrollTop() <= infoHeight) {
                        $(".navigation").siblings(".navigation-placeholder").css("padding-bottom", "0");
                    } else if (!infoHeight && $(window).scrollTop() === 0) {
                        $(".navigation").siblings(".navigation-placeholder").css("padding-bottom", "0");
                    }
                    setTimeout(function () {
                        $('.navigation').css("transition", '');
                    }, 250);
                }
            });


            $(".nav__content").on("transitionend", function () {
                if (!menuOpened) {
                    $(".nav__container").removeClass("nav--black-bg");
                }
            })

            $(".nav__content").on("transitionend", function () {
                if (!menuOpened) {
                    $(".nav__container").removeClass("nav--black-bg");
                }
            })

            // $(".nav__link").on("click", function () {
            //     if($(".navigation").hasClass("opened")){
            //         $(".navigation").removeClass("opened");
            //     }
            // })

            $(".menu-item-has-children ").on("click", function (e) {

                // e.stopPropagation();
                $(this).children(".sub-menu").addClass("sub-menu--opened");
                $(this).addClass("menu-item--opened");


                // $(".sub-menu__hide").off("click", function (e) {
                // e.preventDefault();
                // $(this).parent().removeClass("sub-menu--opened");
                // $(this).parent().parent().removeClass("menu-item--opened");
                // });
            })
            //
            $(".sub-menu__hide").on("click", function (e) {
                e.stopPropagation();
                $(this).parent().removeClass("sub-menu--opened");
                $(this).parent().parent().removeClass("menu-item--opened");
            });

            const nav = $(".nav__mobile-header");
            $(window).scroll(function () {
                if (window.pageYOffset > 0) {
                    nav.addClass("nav__mobile-header--background")
                } else {
                    nav.removeClass("nav__mobile-header--background")
                }
            })

        });


        //Display submenu items as columns when used titles
        $('.navigation__items > .header__menu_item > .header__submenu > .header__submenu_links > .menu-item').each(function () {
            if ($(this).hasClass('menu-item-title')) {
                $(this).parent().css('display', 'flex')
            }
        })

        //Sets submenu left position on desktop on load and when on hover in.
        //Only if submenu overflows screen
        $(window).on('load', function () {
            $('.navigation__items > .header__menu_item').each(function () {
                var $this = $(this);

                //Display submenu, check width and hide
                $(this).children('.header__submenu').css('display', 'block');
                var $linksWidth = $(this).children('.header__submenu').outerWidth();
                $(this).children('.header__submenu').css('display', '');

                var $documentWidth = $(document).outerWidth();
                var $offset = $(this).offset().left;
                var left = ($documentWidth - $offset) - $linksWidth - 15;
                if ($linksWidth > $documentWidth - $offset) {
                    $this.children('.header__submenu').css('left', left)
                }
                $(window).on("mouseenter", function () {
                    $documentWidth = $(document).outerWidth();
                    $offset = $this.offset().left;
                    $linksWidth = $this.children('.header__submenu').outerWidth();
                    left = ($documentWidth - $offset) - $linksWidth - 15;
                    if ($linksWidth > $documentWidth - $offset) {
                        $this.children('.header__submenu').css('left', left)
                    }
                });

            });

        });

        //Wrap menu items when should be in columns
        $('.menu-item-column').each(function () {
            $(this).parent().addClass('header__submenu_links-row');
            $(this).nextUntil($('.menu-item-column')).andSelf().wrapAll("<div class='header__submenu_links-col'></div>");
        })

    })(jQuery);
}